import '@/app/styles/index.css';

import { useSessionStore } from '@/entities/session';
import { attachAuthInterceptor } from '@/shared/api/axios.instance';
import BugsnagPerformance from '@bugsnag/browser-performance';

import { ENV } from '@/shared/lib/env';
import type { FC } from 'react';
import {
  AntdProvider,
  BUGSNAG_API_KEY,
  BugsnagErrorBoundary,
  OverlaysProvider,
  QueryClientProvider,
  RouterProvider,
} from './providers';

attachAuthInterceptor(
  () => useSessionStore.getState().accessToken,
  (accessToken) => useSessionStore.setState({ accessToken }),
  () => useSessionStore.getState().logout()
);

if (ENV.isProduction && BUGSNAG_API_KEY) {
  BugsnagPerformance.start({
    apiKey: BUGSNAG_API_KEY,
  });
}
export const App: FC = () => {
  return (
    <BugsnagErrorBoundary>
      <QueryClientProvider>
        <AntdProvider>
          <OverlaysProvider>
            <RouterProvider />
          </OverlaysProvider>
        </AntdProvider>
      </QueryClientProvider>
    </BugsnagErrorBoundary>
  );
};
